import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import FadeInView from "./FadeInView";

export default function NewLandingCtaBand() {
  const navigate = useNavigate();

  return (
    <section className="cta-section">
      <FadeInView className="cta-band" y={28}>
        <div className="cta-inner-wrap">
          <h2 className="cta-headline">
            Strengthen Your Argument Before Opposing Counsel Attacks It.
          </h2>
          <p className="cta-sub">
            Run your legal issue through multiple AIs, expose weak spots, and get
            a clearer strategy before you file, respond, or negotiate.
          </p>
          <motion.button
            type="button"
            className="cta-btn nl-btn-unstyled"
            onClick={() => navigate("/pricing")}
            whileHover={{ y: -2, scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            transition={{ duration: 0.2 }}
          >
            Start 7-Day Free Trial →
          </motion.button>
        </div>
      </FadeInView>
    </section>
  );
}
